import notFoundImg from "./img/404.png";

import "./style.scss";

const NotFound = () => {
    return (
        <div className="not-found">
            <img src={notFoundImg} />
            <span className="not-found__title">Что-то пошло не так</span>
            <span className="not-found_desc">К сожалению, у вас нет доступа к этой странице</span>
        </div>
    );
};

export default NotFound;
